module.exports = __webpack_public_path__ + "img/wallet.754f6552.svg";